/*
 * @Author: your name
 * @Date: 2022-02-23 09:06:09
 * @LastEditTime: 2022-03-02 09:26:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/store/modules/user.js
 */
import {
  login,
  logout,
  getInfo
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  resetRouter
} from '@/router'

import settingApi from '@/api/setting'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    company: '',
    avatar: '',
    customer: {},
    routeGather: [], // 权限路由
    userInfo: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    document.cookie = `vue_admin_template_token=${token}`
  },
  SET_userInfo: (state, info) => {
    state.userInfo = info
    console.warn('警告')
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_COMPANY: (state, company) => {
    state.company = company
  },
  CUSTOMER: (state, data) => {
    state.customer = data
  },
  SET_routeGather: (state, routes) => {
    state.routeGather = routes
  }
}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const {
            code,
            data
          } = response
          if (data !== null) {
            localStorage.setItem('userInfo', JSON.stringify(data.UserInfo))
            console.warn('登录')
            commit('SET_TOKEN', data.token)
            commit('SET_NAME', data.UserInfo.fuserName)
            const company = `${data.UserInfo.fuserName}--${data.UserInfo.funitName}`
            commit('SET_COMPANY', company)
            commit('SET_userInfo', data.UserInfo)
            setToken(data.token)
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  userSetRoute({
    commit
  }, routes = []) {
    // 用户权限配置
    let userInfo = {}
    const {
      fuserId,
      ftype
    } = userInfo = JSON.parse(localStorage.getItem('userInfo') || JSON.stringify({}))
    let initRoute = routes.filter(item => item.hidden)
    let settingRoute = routes.filter(item => !item.hidden)
    if (fuserId) {
      commit('SET_userInfo', userInfo)
      if (ftype !== 1) {
        settingApi(res => {
          const resData = res.data.DemandUserModule.map(item => item.FModuleName)
          settingRoute = settingRoute.filter(item => {
            const index = resData.indexOf(item.meta.title)
            if (index > -1 && item.meta.title) {
              let pageSetting = res.data.DemandUserModule[index].FFunctions || ''
              pageSetting = pageSetting.split(',')
              item.meta.pageSetting = pageSetting
              return true
            }
          })
          initRoute = initRoute.concat(settingRoute)
          commit('SET_routeGather', initRoute)

        //   console.log(res, settingRoute, this.$store, this.routeGather, '屏幕权限')
        })
        return
      } else {
        initRoute = initRoute.concat(settingRoute)
      }
    } else {
      settingRoute = []
    }
    commit('SET_routeGather', initRoute)
  },

  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const {
            data
          } = response
          if (!data) {
            return reject('Verification failed, please Login again.')
          }
          const {
            name,
            avatar
          } = data
          commit('SET_NAME', name)
          commit('SET_AVATAR', avatar)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken() // must remove  token  first
          resetRouter()
          commit('RESET_STATE')
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
